/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cx } from "@panda/css";
import { HStack } from "@panda/jsx";

const loading = css({
	border: "token(spacing.eds.dimension.8) solid token(colors.eds.palette.grayscale.gray020)",
	borderTop: "token(spacing.eds.dimension.8) solid token(colors.eds.palette.grayscale.gray120)",
	borderRadius: "50%",
	width: "200px",
	height: "200px",
	animation: "spin 1.5s linear infinite",
});

export interface LoadingProps {
	className?: string;
	fill?: boolean;
}

export const DefaultLoading = ({ className = "", fill = true }: LoadingProps): React.JSX.Element => {
	return (
		<div className={cx(`default-loading`, className)}>
			<HStack
				justifyContent={"center"}
				alignItems={"center"}
				h={fill ? "94vh" : "auto"}
				paddingBottom={fill ? "eds.dimension.72" : ""}
				maxWidth="500px"
				margin="0 auto"
			>
				<div className={loading} />
			</HStack>
		</div>
	);
};
